import { FlowNodeTypes, type RConnection, type ROutputNode } from '../types'

// The runner derives the runnable node set from connection endpoints, so a
// Trigger that sources no connection makes the flow unrunnable (SER-6172).
export const isStartNodeWired = (
  nodes: Pick<ROutputNode, 'id' | 'component'>[],
  connections: Pick<RConnection, 'source'>[],
): boolean => {
  const startNodeId = nodes.find((node) => node.component === FlowNodeTypes.start)?.id
  if (!startNodeId) return false
  return connections.some((connection) => connection.source.startsWith(`${startNodeId}.`))
}
